import { render } from "./AccountDetail.vue?vue&type=template&id=28429444&scoped=true"
import script from "./AccountDetail.js?vue&type=script&lang=js&external"
export * from "./AccountDetail.js?vue&type=script&lang=js&external"

import "./AccountDetail.scss?vue&type=style&index=0&id=28429444&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28429444"]])

export default __exports__